// The parent theme adds .sticking only once the page scrolls past the header. A sticky header
// that doesn't overlay the page sticks from the first pixel, so it needs its background as soon
// as the page scrolls; otherwise content shows through the transparent header until .sticking.
function registerScrolledHeader() {
    const { hooks } = window.sitchco;
    const header = document.querySelector('.has-site-header-sticky:not(.has-site-header-overlay)');
    if (!header) {
        return;
    }

    const update = (top) => header.classList.toggle('scrolled', top > 0);
    hooks.addAction('scroll', (event, position) => update(position.top));
    update(window.scrollY);
}

const { register } = window.sitchco;
register(registerScrolledHeader);
